import { IVerifyDomainRes } from 'types/api';
import { useQuery } from 'react-query';
import { useAuthContext } from 'contexts/AuthContext';
import { get } from './api';
import { API_ROUTES } from './apiRoutes';
import QueryKeys from './queryKeys';

export const verifyDomain = async (domain: string) => {
	const res = await get<IVerifyDomainRes>(API_ROUTES.verifyDomain(domain));

	// throw to invoke a retry
	if (!res.data.verified) {
		throw new Error('Domain verification failed');
	}

	return res.data;
};

export const useRetryVerifyDomain = (
	domain: string,
	retryDelayMs: number = 5000
) => {
	const { authRes } = useAuthContext();

	return useQuery({
		queryKey: [QueryKeys.verifyDomain, domain],
		queryFn: () => verifyDomain(domain),
		retry: true,
		enabled: authRes.verified,
		retryDelay: retryDelayMs,
		staleTime: Infinity
	});
};
